import {
  BEARER_ROUTE_PREFIXES,
  isBearerQueryParam,
} from "@shared/security/bearer-urls";
import { hasEmailedSignInMarker } from "@shared/auth/emailed-sign-in-marker";

export const REPLAY_START_INPUT_EVENTS = [
  "pointerdown",
  "keydown",
  "scroll",
] as const;

export const REPLAY_START_IDLE_TIMEOUT_MS = 3000;

export const REPLAY_START_LOAD_WAIT_MS = 5000;

let isReplayBlockedForPage = false;

export function blockReplayForPage(): void {
  isReplayBlockedForPage = true;
}

function onFirstInput(callback: () => void): () => void {
  const stopListening = () => {
    for (const eventName of REPLAY_START_INPUT_EVENTS) {
      window.removeEventListener(eventName, callback, { capture: true });
    }
  };
  for (const eventName of REPLAY_START_INPUT_EVENTS) {
    window.addEventListener(eventName, callback, {
      capture: true,
      passive: true,
    });
  }
  return stopListening;
}

function afterLoadOrDeadline(callback: () => void): void {
  if (document.readyState === "complete") {
    callback();
    return;
  }
  let hasRun = false;
  const runOnce = () => {
    if (hasRun) return;
    hasRun = true;
    callback();
  };
  window.addEventListener("load", runOnce, { once: true });
  window.setTimeout(runOnce, REPLAY_START_LOAD_WAIT_MS);
}

function whenIdle(callback: () => void): void {
  if (window.requestIdleCallback) {
    window.requestIdleCallback(callback, {
      timeout: REPLAY_START_IDLE_TIMEOUT_MS,
    });
  } else {
    window.setTimeout(callback, REPLAY_START_IDLE_TIMEOUT_MS);
  }
}

export function scheduleReplayStart(startRecording: () => void): void {
  let hasStarted = false;
  const startOnce = () => {
    if (hasStarted) return;
    hasStarted = true;
    stopListening();
    if (!isReplayBlockedForPage) startRecording();
  };
  const stopListening = onFirstInput(startOnce);
  afterLoadOrDeadline(() => whenIdle(startOnce));
}

export function isBearerTokenVisit(): boolean {
  if (typeof window === "undefined") return false;
  return (
    BEARER_ROUTE_PREFIXES.some((prefix) =>
      window.location.pathname.startsWith(prefix),
    ) ||
    Array.from(new URLSearchParams(window.location.search).keys()).some(
      isBearerQueryParam,
    ) ||
    hasEmailedSignInMarker(window.location.hash)
  );
}
